import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select, Button, Spin, Col } from 'antd';

import i18n from 'services/i18n';
import { IS_CRITERIA, GENDER, FILTER_TYPE } from 'constants/options';

@i18n('form')
@Form.create()
class GenderFilter extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    form: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
  };

  static defaultProps = {
    loading: false,
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const data = {
          criterion: {
            gender: values.gender,
            isSimPatHasCriterion: values.isSimPatHasCriterion === 'is', // convert to bool
          },
        };
        this.props.onSubmit(FILTER_TYPE.GENDER, data);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Spin spinning={this.props.loading}>
        <Form
          className="criteria-form"
          layout="horizontal"
          onSubmit={this.handleSubmit}
        >
          <Input.Group>
            <Col span={10}>
              <Form.Item wrapperCol={{ span: 24 }} className="form-full-width">
                {getFieldDecorator('isSimPatHasCriterion', {
                  initialValue: 'is',
                })(
                  <Select placeholder={this.props.translate('chooseOptions')}>
                    {IS_CRITERIA.map(item => (
                      <Select.Option key={item.value} value={item.value}>
                        {this.props.translate(item.value)}
                      </Select.Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col span={14}>
              <Form.Item wrapperCol={{ span: 24 }} className="form-full-width">
                {getFieldDecorator('gender', {
                  initialValue: 'MALE',
                })(
                  <Select placeholder={this.props.translate('chooseGender')}>
                    {GENDER.map(item => (
                      <Select.Option key={item.value} value={item.value}>
                        {this.props.translate(item.value)}
                      </Select.Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Input.Group>
          <Button htmlType="submit" icon="plus" className="add-btn">
            {this.props.translate('add')}
          </Button>
        </Form>
      </Spin>
    );
  }
}

export default GenderFilter;
